function showSubscriptionSelect(disp_flg){
  if(disp_flg == "1"){
    document.getElementById('selling_plan').selectedIndex = 0;
    document.getElementById('subscriupt_select').style.display = 'none';
  } else if(disp_flg == "2") {
    document.getElementById('subscriupt_select').style.display = 'block';
  }
}

var cartStatusFlg = '0';
function setCartStatus(status){
  cartStatusFlg = status;
}
function checkCartItem() {

  checkCartEmpty();
  
  let elems = document.getElementsByName("plan");
  let val = "";
  for (let i = 0; i < elems.length; i++) {
    if (elems[i].checked){
  	  val = elems[i].value;
    }
  }
  
  if(val == 'tanpatsu' || val == ''){
    if(cartStatusFlg == '3' || cartStatusFlg == '4' || cartStatusFlg == '5'){
      alert('通常商品と定期商品は同時にご注文できません。');
      return false;
    }
    cartStatusFlg = '1';
  } else if(val == 'subscription'){
    let elems2 = document.getElementsByName("planOption");
    let val2 = "";
    for (let i = 0; i < elems2.length; i++) {
      if (elems2[i].checked){
  	    val2 = elems2[i].value;
      }
    }
    if(val2 == '3117154557'){
      if(cartStatusFlg == '1' || cartStatusFlg == '4' || cartStatusFlg == '5'){
        alert('配送頻度が異なる商品は同時にご注文できません。');
        return false;
      }
      cartStatusFlg = '3';
      
    } else if(val2== '3117187325'){
      if(cartStatusFlg == '1' || cartStatusFlg == '3' || cartStatusFlg == '5'){
        alert('配送頻度が異なる商品は同時にご注文できません。');
        return false;
      }
      cartStatusFlg = '4';
      
    } else if(val2=='3119382781'){
      if(cartStatusFlg == '1' || cartStatusFlg == '3' || cartStatusFlg == '4'){
        alert('配送頻度が異なる商品は同時にご注文できません。');
        return false;
      }
      cartStatusFlg = '5';
    }

  }
}
function checkCartEmpty() {
  var url = "/cart.json";
  var request = new XMLHttpRequest();
  var result = "";
  request.open("GET", url, false);
  request.onreadystatechange = function () {
      if (request.readyState != 4) {
          // リクエスト中
      } else if (request.status != 200) {
          // 失敗
      } else {
          // 取得成功
          result = request.responseText;
      }
  }
  request.send(null);
  let resultData = JSON.parse(result);

  if(resultData.item_count == 0){
    setCartStatus(0);
  }
}
